import { useState } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import RequestServies from "../../../services/RequestServies";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";

const FabricationReport = () => {
  const [open, setOpen] = useState(true);
  const [open2, setOpen2] = useState(true);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("all");
  const [totalcount, setTotalCount] = useState(0);
  const [expandedIndex, setExpandedIndex] = useState(null);

  const fetchReport = async () => {
    if (!fromDate || !toDate) {
      Swal.fire({ icon: "warning", title: "Missing Dates", text: "Please select both From and To dates." });
      return;
    }
    setLoading(true);
    try {
      const response = await RequestServies.reportFabrication({ fromDate, toDate, status });
      console.log(response)
      setReportData(response.data);
      setTotalCount(response.count);
      Swal.fire({ icon: "success", title: "Report Generated", text: "Fabiraction Report Successfully Generated." });
    } catch (error) {
      Swal.fire({ icon: "error", title: "Error", text: "Failed to fetch report data." });
    } finally {
      setLoading(false);
    }
  };

  const toggleDetails = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  const downloadExcel = () => {
    if (reportData.length === 0) {
      Swal.fire({
        icon: "info",
        title: "No Data",
        text: "No data available to download.",
      });
      return;
    }

    const mainData = reportData.map((item, index) => ({
      "S.No": index + 1,
      "Store": item?.storeId?.name || "N/A",  // Corrected store name reference,
      "Created Date": item?.fabricationDate?.split("T")[0],
      "Fabrication No": item?.fabricationNo,
      "Status": item?.status,
    }));

    const sentItemsData = reportData.flatMap((item, index) =>
      item.sentItems.map((sent, i) => ({
        "Main S.No": index + 1,
        "store":sent?.inventoryId?.store?.name || "N/A", // Corrected store reference
        "Part No": sent?.inventoryId?.masterItem?.partNo || "N/A",
        "Description": sent?.inventoryId?.masterItem?.description || "N/A",
        "Unit":sent?.inventoryId?.masterItem?.unit?.name,
        "Quantity": sent.quantity,
      }))
    );

    const receivedItemsData = reportData.flatMap((item, index) =>
      item.receivedItem.map((received, i) => ({
        "Main S.No": index + 1,
        "store":received?.inventoryId?.store?.name || "N/A", // Corrected store reference
        "Part No": received?.inventoryId?.masterItem?.partNo || "N/A",
        "Description": received?.inventoryId?.masterItem?.description,
        "Unit": received?.inventoryId?.masterItem?.unit?.name,
        "Quantity": received.quantity,
      }))
    );

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(mainData), "Main Table Data");
    XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(sentItemsData), "Sent Items Data");
    XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(receivedItemsData), "Received Items Data");

    const fileName = `Fabrication_Report_${new Date().toISOString().split("T")[0]}.xlsx`;
    XLSX.writeFile(workbook, fileName);
    Swal.fire({
      icon: "success",
      title: "Download Successful",
      text: `File "${fileName}" has been downloaded successfully.`,
    });
  };

  return (
    <div className="col-xl-12">
      <div className="filter cm-content-box box-primary">
        <div className="content-title">
          <div className="cpa">
            <i className="fas fa-filter me-2"></i>Filter
          </div>
          <div className="tools">
            <Link to={"#"} className={`SlideToolHeader ${open ? "collapse" : "expand"}`} onClick={() => setOpen(!open)}>
              <i className="fas fa-angle-up"></i>
            </Link>
          </div>
        </div>
        <Collapse in={open}>
          <div className="cm-content-body form excerpt">
            <div className="card-body">
              <div className="row">
                <div className="col-xl-3">
                  <label className="ms-2">From</label>
                  <input type="date" className="form-control" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                </div>
                <div className="col-xl-3">
                  <label className="ms-2">To</label>
                  <input type="date" className="form-control" value={toDate} onChange={(e) => setToDate(e.target.value)} />
                </div>
                <div className="col-xl-3">
                  <label className="ms-2">Status</label>
                  <select 
                  className="form-select"
                  style={{ height: '55px' }}
                   value={status} 
                   onChange={(e) => setStatus(e.target.value)}>
                    <option value="all">All</option>
                    <option value="completed">Completed</option>
                    <option value="initiated">Initiated</option>
                  </select>
                </div>
                <div className="col-xl-3">
                  <label className="ms-2">Search</label>
                  <button className="form-control btn btn-primary" onClick={fetchReport} disabled={loading}>
                    {loading ? "Loading..." : "Generate Report"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Collapse>
      </div>
      <div className="filter cm-content-box box-primary">
        <div className="content-title">
          <div className="cpa">
            <i className="fa fa-list me-2"></i>Fabrication Report<span className="badge bg-orange ms-2">{totalcount}</span>
          </div>
          <div className="tools">
            <Link to={"#"} className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`} onClick={() => setOpen2(!open2)}>
              <i className="fas fa-angle-up"></i>
            </Link>
          </div>
        </div>
        <Collapse in={open2}>
          <div className="cm-content-body form excerpt">
            <div className="card-body">
            <div className="mb-3 text-end">
                                {!loading && reportData?.length > 0 ? (
                                    <p  onClick={downloadExcel} className="text-end btn btn-rounded btn-md btn-primary me-3">
                                        <i className="las la-download scale5 me-3"></i> Download Report
                                    </p>
                                ) : (
                                    <p></p>
                                )}

                            </div>
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Store</th>
                      <th>fabrication Date</th>
                      <th>Fabrication No</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {reportData.length > 0 ? (
                      reportData.map((item, index) => (
                        <>
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item?.storeId?.name}</td>
                            <td>{item?.fabricationDate?.split("T")[0]}</td>
                            <td>{item?.fabricationNo}</td>
                            <td>{item?.status}</td>
                            <td>
                              <button className="btn btn-primary btn-sm" onClick={() => toggleDetails(index)}>
                                {expandedIndex === index ? "Hide Details" : "View Details"}
                              </button>
                            </td>
                          </tr>
                          {expandedIndex === index && (
                            <tr>
                              <td colSpan="6">
                                <div className="table-responsive">
                                  <h5>Sent Items</h5>
                                  <table className="table table-bordered">
                                    <thead>
                                      <tr>
                                        <th>Part No</th>
                                        <th>Store</th>
                                        <th>Description</th>
                                        <th>Unit</th>
                                        <th>Quantity</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {item.sentItems.map((sent, i) => (
                                        <tr key={i}>
                                          <td>{sent?.inventoryId?.masterItem?.partNo}</td>
                                          <td>{sent?.inventoryId?.store?.name}</td>
                                          <td>{sent?.inventoryId?.masterItem?.description}</td>
                                          <td>{sent?.inventoryId?.masterItem?.unit.name}</td>
                                          <td>{sent?.quantity}</td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                  <h5>Received Items</h5>
                                  <table className="table table-bordered">
                                    <thead>
                                      <tr>
                                        <th>Part No</th>
                                        <th>Store</th>
                                        <th>Description</th>
                                        <th>Unit</th>
                                        <th>Quantity</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {item.receivedItem.map((received, i) => (
                                        <tr key={i}>
                                          <td>{received?.inventoryId.masterItem.partNo}</td>
                                          <td>{received?.inventoryId?.store?.name}</td>
                                          <td>{received?.inventoryId?.masterItem?.description}</td>
                                          <td>{received?.inventoryId?.masterItem?.unit.name}</td>
                                          <td>{received?.quantity}</td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </td>
                            </tr>
                          )}
                        </>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center">No data available.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </Collapse>
      </div>
    </div>
  );
};

export default FabricationReport;
